import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import {RouterModule} from "@angular/router";
import {LocationStrategy, HashLocationStrategy} from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './token.interceptor';

import {ROUTES} from "./app.routes";
import { AppComponent } from './app.component';

// App views
import {DashboardsModule} from "./views/dashboards/dashboards.module";
import {AppviewsModule} from "./views/appviews/appviews.module";
//Patient components
import {PatientModule} from "./views/patients/patients.module"
//Provider components
import {ProviderModule} from "./views/provider/provider.module"
//Employer
import {EmployerModule} from "./views/employer/employer.module"
//DPR
import {DprModule} from "./views/dpr/dpr.module"

//Audit
import {AuditModule} from "./views/audit/audit.module"


// App modules/components
import {LayoutsModule} from "./components/common/layouts/layouts.module";


import { PatientService } from './patient.service'
import { LoginService } from './login.service'
import { AuthContextService } from './auth-context.service'

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    DashboardsModule,
    HttpClientModule,
   
    PatientModule,
    ProviderModule,
    EmployerModule,
    DprModule,
    AuditModule,

    LayoutsModule,
    AppviewsModule,
    RouterModule.forRoot(ROUTES)
  ],
  providers: [HttpClientModule,PatientModule,ProviderModule,EmployerModule,DprModule,AuditModule,PatientService,LoginService,AuthContextService, {provide: LocationStrategy, useClass: HashLocationStrategy},{
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts